const body = document.body;
const scrollUp = "scroll-up";
const scrollDown = "scroll-down";
const sticky = 'sticky';
let lastScroll = 0;


export const initHeader = () => {
  const header = document.getElementsByClassName('header')[0];
  let isInit = body.classList.contains(scrollDown) || body.classList.contains(scrollUp);

  window.addEventListener("scroll", () => {
    const currentScroll = window.pageYOffset;
    const headerHeight = header.offsetHeight + 100;

    if (currentScroll == 0) {
      body.classList.remove(scrollUp);
      header.classList.remove(sticky);
      return;
    }



    if (currentScroll > lastScroll && currentScroll > headerHeight && !body.classList.contains(scrollDown)) {
      // down
      body.classList.remove(scrollUp);
      body.classList.add(scrollDown);
    } else if (currentScroll < lastScroll && body.classList.contains(scrollDown)) {
      // up
      body.classList.remove(scrollDown);
      body.classList.add(scrollUp);

      !header.classList.contains(sticky) && header.classList.add(sticky);
    }
    lastScroll = currentScroll;
  })
} ;
